// extracted by mini-css-extract-plugin
export var clauseRow = "_f1-6";
export var emptyState = "_f1-d";
export var filterContent = "_f1-a";
export var filterGroup = "_f1-1";
export var filterGroupContainer = "_f1-0";
export var nestedGroup = "_f1-2";
export var nestedGroupContent = "_f1-b";
export var nestedGroupDepth1 = "_f1-3";
export var nestedGroupDepth2 = "_f1-4";
export var nestedGroupDepth3 = "_f1-5";
export var nestedGroupEmpty = "_f1-c";
export var operatorAnd = "_f1-8";
export var operatorOr = "_f1-9";
export var operatorToggle = "_f1-7";
export var removeGroupButton = "_f1-e";